import { jsx as _jsx } from "@emotion/react/jsx-runtime";
export const SvgChevronDownSingle = () => {
    return (_jsx("svg", Object.assign({ viewBox: "0 0 30 30", xmlns: "http://www.w3.org/2000/svg" }, { children: _jsx("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M4 9.95L14.45 20.4H15.45L25.8999 9.95L24.9249 9L14.95 17.4L4.975 9L4 9.95Z" }, void 0) }), void 0));
};
//# sourceMappingURL=chevron-down-single.js.map
